<div class="input-card">
  <span class="input-name">{{ input.name }}</span>
  <span class="input-type">{{ 'input.type.' + input.type | translate }}</span>
  <button class="settings-button" (click)="onEdit()">
    <img src="assets/icons/edit.svg" width="20" height="20" [alt]="'common.edit' | translate" />
  </button>
  <div *ngIf="input.type !== 'Counter'" class="led-indicator" [class.active]="input.state === 'on'"></div>

  <!-- Counter: shows the reading in the configured unit; click it to set it to what the
       physical meter says. -->
  <div *ngIf="input.type === 'Counter' && !editingCounter"
       class="counter-value" [title]="'input.counter.set_hint' | translate" (click)="startEdit()">
    {{ counterText }}
  </div>
  <div *ngIf="input.type === 'Counter' && editingCounter" class="counter-edit">
    <input type="number" step="any" [(ngModel)]="counterInput" />
    <span class="counter-unit">{{ unit }}</span>
    <button (click)="saveCounter()">{{ 'common.set' | translate }}</button>
    <button (click)="cancelCounter()">{{ 'common.cancel' | translate }}</button>
  </div>
</div>
